import React from 'react';

import '../../../../css/global/informationsquare.scss';

const InformationSquare = ({title, mainContent, className, clickEvent }:{title?:JSX.Element, mainContent?: JSX.Element, className?:string, clickEvent?: () => void}) => {
    return (
        <div role={clickEvent ? 'button' : ''} className={`information-square-container ${className || ''}`} onClick={clickEvent} style={{cursor: clickEvent ? 'pointer' : 'default'}}>
            {title && <span className='title'>{title}</span>}
            {mainContent && mainContent}
        </div>
    )
}

export default InformationSquare;